export default {
  error: {
    returnToHomeButton: "العودة إلى الصفحة الرئيسية"
  },
  notFound: {
    returnToHomeButton: "العودة إلى الصفحة الرئيسية",
    title: "خطأ 404",
    subtitle: "عذرًا! الصفحة التي تبحث عنها غير موجودة.",
    description: "قد تكون أدخلت الرابط بشكل غير صحيح."
  }
};
